<template>
  <div class="event-public-page">
    <div id="eventDetailCarousel" class="carousel slide event-hero" data-bs-ride="carousel" v-if="banners.length">
      <div class="carousel-indicators">
        <button
          v-for="(b, idx) in banners"
          :key="'detail-ind-' + idx"
          type="button"
          data-bs-target="#eventDetailCarousel"
          :data-bs-slide-to="idx"
          :class="{ active: idx === 0 }"
          :aria-current="idx === 0 ? 'true' : 'false'"
          :aria-label="'Slide ' + (idx + 1)"
        ></button>
      </div>
      <div class="carousel-inner">
        <div v-for="(b, idx) in banners" :key="'detail-hero-' + idx" class="carousel-item" :class="{ active: idx === 0 }">
          <div class="event-hero-slide" :style="{ backgroundImage: `url(${b.imageUrl})` }">
            <div class="event-hero-mask">
              <div class="event-hero-content">
                <div class="event-hero-title">{{ b.title || event.title }}</div>
                <div class="event-hero-subtitle">{{ b.subtitle || event.status || '' }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <button class="carousel-control-prev" type="button" data-bs-target="#eventDetailCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Previous</span>
      </button>
      <button class="carousel-control-next" type="button" data-bs-target="#eventDetailCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="visually-hidden">Next</span>
      </button>
    </div>

    <div class="container event-public-body">
      <div class="d-flex align-items-center justify-content-between gap-2 flex-wrap mb-2">
        <h2 class="mb-0">{{ event.title || '赛事详情' }}</h2>
        <button type="button" class="btn btn-sm btn-light" @click="goBack">返回赛事介绍</button>
      </div>
      <div class="small text-muted mb-3">
        <span>{{ event.seasonYear || '-' }}赛季</span>
        <span class="ms-2" v-if="event.category">{{ event.category }}</span>
        <span class="ms-2" v-if="event.status">{{ event.status }}</span>
        <span class="ms-2" v-if="event.timeText">{{ event.timeText }}</span>
      </div>

      <div class="card event-tag-card">
        <div class="card-body">
          <div class="event-tag-desc event-rich-detail-html" v-html="detailHtml"></div>
        </div>
      </div>

      <div class="event-detail-bottom-spacer"></div>
      <div class="event-detail-bottom-join">
        <button type="button" class="btn btn-success event-detail-join-btn" @click="joinEvent">
          参加赛事
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EventDetailPublicView',
  data() {
    return {
      event: {},
      banners: []
    }
  },
  computed: {
    detailHtml() {
      const raw = String((this.event && (this.event.detail || this.event.summary)) || '').trim()
      if (!raw) return '暂无赛事介绍。'
      if (/<[a-z][\s\S]*>/i.test(raw)) return raw
      const escaped = raw
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
      return escaped.replace(/\n/g, '<br/>')
    }
  },
  async created() {
    await this.loadDetail()
  },
  methods: {
    async loadDetail() {
      const id = this.resolveEventId()
      if (!id) {
        window.alert('缺少赛事ID')
        return
      }
      const res = await fetch(`/api/event/public/detail/${id}`).then((r) => r.json())
      if (!res || res.code !== 200) {
        window.alert((res && res.message) || '加载赛事详情失败')
        return
      }
      const data = res.data || {}
      this.event = data.event || {}
      this.banners = data.banners || []
    },
    resolveEventId() {
      const hash = String(window.location.hash || '')
      const m = hash.match(/^#\/event\/detail\/(\d+)/)
      if (m && m[1]) return Number(m[1])
      return null
    },
    goBack() {
      window.location.hash = '#/event'
    },
    joinEvent() {
      const raw = String((this.event && (this.event.joinLink || this.event.joinPayload)) || '').trim()
      if (!raw) {
        window.alert('暂未配置参加赛事跳转链接')
        return
      }
      let url = raw
      try {
        if (raw.startsWith('{') && raw.endsWith('}')) {
          const o = JSON.parse(raw)
          if (String((o && o.type) || '').trim().toLowerCase() === 'url') {
            url = String((o && o.url) || '').trim()
          }
        }
      } catch (e) {
        // keep raw as url text
      }
      if (!url) {
        window.alert('参加赛事链接无效')
        return
      }
      window.open(url, '_blank', 'noopener,noreferrer')
    }
  }
}
</script>

<style scoped>
.event-hero { width: 100%; }
.event-hero-slide { height: 320px; background-size: cover; background-position: center; }
@media (min-width: 992px) { .event-hero-slide { height: 420px; } }
.event-hero-mask { height: 100%; width: 100%; background: linear-gradient(90deg, rgba(0,0,0,.55), rgba(0,0,0,.15)); display: flex; align-items: flex-end; }
.event-hero-content { padding: 22px 16px; width: 100%; max-width: 1100px; margin: 0 auto; color: #fff; }
.event-hero-title { font-size: 26px; font-weight: 700; }
.event-hero-subtitle { margin-top: 6px; font-size: 14px; opacity: .95; }
.event-public-body { padding-top: 18px; padding-bottom: 28px; }
.event-tag-card { border-radius: 14px; overflow: hidden; }
.event-tag-desc { color: #4b5563; line-height: 1.7; font-size: 14px; }
.event-rich-detail-html :deep(img) { max-width: 100%; height: auto; border-radius: 8px; }
.event-rich-detail-html :deep(a) { word-break: break-all; }
.event-detail-bottom-spacer { height: 86px; }
.event-detail-bottom-join {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1200;
  padding: 12px 16px calc(12px + env(safe-area-inset-bottom));
  border-top: 1px solid #dbe5f4;
  background: rgba(255, 255, 255, 0.96);
  box-shadow: 0 -8px 20px rgba(31, 57, 92, 0.12);
  display: flex;
  justify-content: center;
}
.event-detail-join-btn {
  min-width: min(420px, 92vw);
  max-width: 620px;
  width: 100%;
  font-weight: 700;
}
</style>

